import Vue from 'vue'
import Router from 'vue-router'
import {
  Health, Dashboard, Login
} from './views'
import auth from './views/middleware/auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/health',
      name: 'health',
      component: Health
    },
    {
      path: '/',
      name: 'home',
      component: Dashboard,
      meta: {
        middleware: [auth]
      }
    },
    {
      path: '/signin',
      name: 'signin',
      component: Login
    }
  ]
})
